// Return a boolean after comparing coordinate array pairs
const coordinateDifference = (a, b) => {
  return a[0] !== b[0] || a[1] !== b[1] ? true : false;
};

export { coordinateDifference };
